var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-link',{attrs:{"to":{
    name: 'Service',
    params: { id: _vm.service.id, slug: _vm.service.slug, title: _vm.service.name },
  }}},[_c('div',{staticClass:"card place-card"},[_c('img',{staticClass:"card-image",attrs:{"src":_vm.service.image.smallUrl,"alt":""}}),_c('div',{staticClass:"card-body"},[_c('h4',{staticClass:"card-title"},[_vm._v(_vm._s(_vm.service.name))])])])])}
var staticRenderFns = []

export { render, staticRenderFns }